// Settings, Renewal sheets (the Manager and the Admin): the temporary page that replaces the Mac
// catch-up until the VAs move to the portal. Nothing is loaded; the card talks to the server on use.
import type { Api } from '../auth/api';
import { RenewalSheetsCard } from '../settings/RenewalSheetsCard';
import { SettingsNav } from '../settings/SettingsNav';
import { sheetCopy } from '../settings/sheet-upload-lines';
import { PageHeader } from '../shell/PageHeader';

export function RenewalSheetsPage({ api }: { api: Api }) {
  return (
    <>
      <PageHeader title="Settings" subtitle="Changes apply to everyone in the department" />
      <div className="setwrap">
        <SettingsNav current="/settings/sheets" />
        <div className="setcol">
          <h2 className="dtitle">{sheetCopy.title}</h2>
          <p className="esub m0">{sheetCopy.subtitle}</p>
          <RenewalSheetsCard api={api} />
        </div>
      </div>
    </>
  );
}
